<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-brand center>Job Order Details</b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain">New Purchase Order</b-button>
            </b-nav-form>
          </b-navbar-nav> -->
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-container fluid>
              <b-row class="gutr">
                <b-col md="12" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="itemServiceDetails" :fields="fields"
                  :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
                  <template slot="jobOrderTptId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="jobOrderSeries" slot-scope="row1">
                    <span @click="viewServiceEstimationPage(row1.item.jobOrderTptId,row1.item.serviceEstimationId)"
                      class="showMoreData">{{row1.item.jobOrderSeries}}</span>
                  </template>

                  <template slot="loginTime" slot-scope="row116">
                    <span>{{row116.item.loginTime | moment}}</span>
                  </template>

                  <template slot="updateTime" slot-scope="row12">
                    <span>{{row12.item.updateTime | moment}}</span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import CustomLoader from "../../common/customLoader.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/jobOrderSheet/viewJobOrder");

      this.viewServiceEstimation();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
        fields: [
        {
          key: "jobOrderTptId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "jobOrderSeries",
          label: "Job order No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "serviceEstSeries",
          label: "Service Estimation No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "jobTypeTptStatus",
          label: "Job Order Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "loginTime",
          label: "Creation Date",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "updateTime",
          label: "Last Updated",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      isLoading: "",
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      alert: {
        content:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      itemServiceDetails: []
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    // Loading
    CustomLoader,
  },
  computed: {
    itemMasterList() {
      return this.itemDetail;
    },
    vehicleMasterList() {
      return this.vehicleDetail;
    },
    locationMasterList() {
      return this.locationMaster;
    },
    employeeMasterList() {
      return this.employeeMaster;
    },

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    removeCss() {
      $(".md-active").remove();
    },

    JqueryFun() {
      return $(function() {
        return $("#jobord").DataTable();
      });
    },

    viewServiceEstimationPage(jobOrderID, serviceEstimationID) {
      this.$sessionsStorage.set("editJobOrderId", jobOrderID);
      this.$sessionsStorage.set("editServiceId", serviceEstimationID);
      this.$router.push({
        path: "/jobOrderSheet/jobOrderSheet"
      });
    },

    viewServiceEstimation() {
      this.isLoading = true;
      let client_detail = {
        view: "view"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewJobOrder.php`,
        data: JSON.stringify(client_detail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemServiceDetails = data.itemArray;
              this.totalRows = data.itemArray.length;
            } else {
              this.itemServiceDetails = [];
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  margin-top: 1px;
}
/* .marg-top {
  margin-top: -1%;
} */

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}
.md-select-content {
  z-index: 999999999;
}

</style>


// WEBPACK FOOTER //
// viewJobOrder.vue?35326fa0